import { useEffect, useState } from "react";

export function useClaimsBumpNotice(authReady: boolean, userId: string | null) {
  const [showLogoutNotice, setShowLogoutNotice] = useState(false);

  useEffect(() => {
    const onBumped = () => setShowLogoutNotice(true);
    window.addEventListener("gw:claims-bumped", onBumped);
    return () => window.removeEventListener("gw:claims-bumped", onBumped);
  }, []);

  useEffect(() => {
    let bc: BroadcastChannel | null = null;
    try {
      bc = new BroadcastChannel("gw-claims");
      bc.onmessage = (ev: MessageEvent) => {
        const t = (ev && (ev as any).data && (ev as any).data.type) || (ev?.data?.type);
        if (t === "claims-bumped") setShowLogoutNotice(true);
      };
    } catch {/* intentionally ignore */}
    return () => {
      try { bc?.close(); } catch {/* intentionally ignore */}
    };
  }, []);

  useEffect(() => {
    if (!authReady) return;
    setShowLogoutNotice(false);
  }, [authReady, userId]);

  return { showLogoutNotice, setShowLogoutNotice };
}
